import CashbackLoyaltyProgram from './CashbackLoyaltyProgram';

export default {
  CashbackLoyaltyProgram,
};
